import { ArrowRight } from "lucide-react";
import { useEffect, useState } from "react";
import type { RequestWorkspaceService } from "../../application/queries/request-workspace";
import type { RequestWorkspaceDetail } from "../../domain/models";
import {
  planningProgressOf,
  PlanningRequestProgress,
} from "./PlanningRequestProgress";

export function PlanningRequestInline({
  requestNo,
  service,
}: {
  requestNo: string;
  service: RequestWorkspaceService;
}) {
  const [detail, setDetail] = useState<RequestWorkspaceDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState("");

  const load = () => {
    setLoading(true);
    setLoadError("");
    service
      .load(requestNo)
      .then(setDetail)
      .catch((error) =>
        setLoadError(
          error instanceof Error ? error.message : "Talep ayrıntısı alınamadı.",
        ),
      )
      .finally(() => setLoading(false));
  };

  useEffect(load, [requestNo, service]);

  if (loading)
    return <p className="request-inline-state">Talep ayrıntısı yükleniyor…</p>;
  if (loadError)
    return (
      <div className="request-inline-state" role="alert">
        <span>{loadError}</span>
        <button className="secondary-button" onClick={load}>
          Yeniden dene
        </button>
      </div>
    );
  if (!detail) return null;
  const progress = planningProgressOf(detail);
  return (
    <div className="planning-request-inline">
      <section
        className="planning-request-flow"
        aria-label="Talebin süreç durumu"
      >
        <PlanningRequestProgress
          request={detail}
          variant="full"
          showNextAction={false}
        />
      </section>
      <div className="planning-request-brief-grid">
        <section
          className="planning-request-next-action"
          aria-label="Sıradaki işlem"
        >
          <span className="planning-request-brief-icon" aria-hidden="true">
            <ArrowRight size={18} />
          </span>
          <div>
            <span className="planning-request-section-label">
              Sıradaki işlem
            </span>
            <p>{progress.nextAction}</p>
          </div>
        </section>
        <section
          className="planning-request-description"
          aria-label="Talep açıklaması"
        >
          <span className="planning-request-section-label">
            Talep açıklaması
          </span>
          <p>{detail.description || "Talep açıklaması girilmemiş."}</p>
        </section>
      </div>
    </div>
  );
}
